import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export function QryptSymbolDark({ className, width = "100%", height = "100%", style }) {
    return /*#__PURE__*/ _jsx("svg", {
        className: className,
        width: width,
        height: height,
        style: style,
        viewBox: "0 0 390.01 388.4",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "m257.37 241.66 122.43 122.43-23.22 23.26-125.39-125.44 18.59 71.67-31.82 8.25-16.67-64.16-29.63 110.73-31.73-8.51 30.77-114.96-111.04 111.03-23.26-23.22 109.59-109.59-97.06 24.96-8.16-31.86 100.16-25.75-140.93-37.75 8.51-31.73 139.01 37.23-45.96-45.96 23.22-23.22 44.26 44.25-37.67-145.07 31.82-8.25 38.62 148.74 25.1-93.79 31.77 8.51-24.52 91.52 111.59-111.6 23.23 23.27-114.7 114.69 127.53-32.77 8.2 31.81-119.63 30.77 85.76 22.96-8.51 31.73z",
            fill: "#171629"
        })
    });
}
